import TemplateView from '../../TemplateView'
import PasswordPolicyManager from './PasswordPolicyManager'


export default class PasswordErrorMessage extends TemplateView {

    constructor({
        additionalClass = "",
        passwordValidationResult = "",
        passwordPolicy = PasswordPolicyManager
    } = {}) {
        super();
        this.state = {
            passwordValidationResult
        };
        this.additionalClass = additionalClass;

        this.onStatePropertyChanged("passwordValidationResult", result => {
            if (!result || result.ok) {
                this.getEl().hide();
            } else {
                this.showError(passwordPolicy.getErrorMessage(result))
            }
        })
    }

    hideError() {
        this.setState({passwordValidationResult: {ok: true}})
    }

    templateHtml() {
        return `<div class="passwordErrorMessage <%=additionalClass%>"></div>`;
    }

    showError(text) {
        this.getEl().show()
        this.getEl().text(text)
    }
}



// WEBPACK FOOTER //
// ./web/js/util/passwords/PasswordErrorMessage.js